import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroupHeadlineComponent } from './form-group-headline/form-group-headline.component';
import { MaterialModule } from '../../material/material.module';
import { UploadFileFormComponent } from './upload-form/upload-file-form.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
    ],
    declarations: [
        FormGroupHeadlineComponent,
        UploadFileFormComponent,
    ],
    exports: [
        FormGroupHeadlineComponent,
        UploadFileFormComponent,
    ],
})
export class FormComponentsModule {
}
